import { Component, Output, EventEmitter } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'csa-modal-bottomsheet',
  templateUrl: './modal-bottomsheet.component.html',
  styleUrls: ['./modal-bottomsheet.component.scss'],
  standalone: false,
})
export class ModalBottomsheetComponent {
  @Output() stopClaiming = new EventEmitter<any>();
  constructor(public dialogRef: MatDialogRef<ModalBottomsheetComponent>) {}

  handleStopClaimingCLick(): void {
    this.dialogRef.close(true);
  }
}
